<script setup lang="ts">
import { ICONS, SPARK_PATH, type IconName } from './icons'

defineProps<{ name: IconName | 'spark' }>()
</script>

<template>
  <svg v-if="name === 'spark'" class="spk" viewBox="0 0 24 24" aria-hidden="true"><path :d="SPARK_PATH" /></svg>
  <!-- static, trusted markup from icons.ts -->
  <svg v-else class="ic" viewBox="0 0 24 24" aria-hidden="true" v-html="ICONS[name]"></svg>
</template>
